export default () => '<div class="content">Ecofoot slip sheet  is required for EcoFoot2 plus products.</div>';
